import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
/**
 * Renders `text` with <mark> spans wrapping the substrings reported by Fuse
 * for the given `field`. Used for the primary identifying field of a result
 * row (system name, user full name, artifact name, ...).
 */ export function EntityPickerHighlightedText({ text, field, matches, className }) {
    const ranges = matches?.filter((m)=>m.key === field).flatMap((m)=>m.indices ?? []);
    if (!ranges || ranges.length === 0) {
        return /*#__PURE__*/ _jsx("span", {
            className: className,
            children: text
        });
    }
    const sorted = [
        ...ranges
    ].sort((a, b)=>a[0] - b[0]);
    const merged = [];
    for (const [start, end] of sorted){
        const last = merged[merged.length - 1];
        if (last && start <= last[1] + 1) {
            last[1] = Math.max(last[1], end);
        } else {
            merged.push([
                start,
                end
            ]);
        }
    }
    const parts = [];
    let cursor = 0;
    merged.forEach(([start, end], i)=>{
        if (cursor < start) parts.push(text.slice(cursor, start));
        parts.push(/*#__PURE__*/ _jsx("mark", {
            children: text.slice(start, end + 1)
        }, `m-${i}`));
        cursor = end + 1;
    });
    if (cursor < text.length) parts.push(text.slice(cursor));
    return /*#__PURE__*/ _jsx("span", {
        className: className,
        children: parts
    });
}

//# sourceMappingURL=EntityPickerHighlightedText.js.map